var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_pro_etalent_com_br_legacy_app_mfe_remoteEntry_js_4d1ac694__;